<template>
	<div class="w-100">
		<b-skeleton-wrapper :loading="display.loading" class="pb-4 mb-4 border-b-semi-grey">
			<template #loading>
				<div class="px-4">
					<b-row class="slim-grid-row">
						<b-col cols="12" class="mb-3">
							<b-skeleton width="20%" height="40px"></b-skeleton>
							<b-skeleton width="50%" height="20px"></b-skeleton>
						</b-col>
						<b-col cols="12">
							<b-card body-class="p-0">
								<b-skeleton-img no-aspect width="100%" height="160px" card-img="top"></b-skeleton-img>
								<b-card-body>
									<b-skeleton width="80%" height="30px"></b-skeleton>  
									<b-skeleton width="30%" height="25px"></b-skeleton>
									<b-row class="slim-grid-row mb-3">
										<b-col cols="3">
											<b-skeleton width="100%" height="20px"></b-skeleton>
										</b-col>
										<b-col cols="3">
											<b-skeleton width="100%" height="20px"></b-skeleton>
										</b-col>
										<b-col cols="3">
											<b-skeleton width="100%" height="20px"></b-skeleton>
										</b-col>
									</b-row>
									<b-row class="slim-grid-row">
										<b-col cols="6">
											<b-skeleton width="100%" height="37px"></b-skeleton>
										</b-col>
										<b-col cols="6">
											<b-skeleton width="100%" height="37px"></b-skeleton>
										</b-col>
									</b-row>
								</b-card-body>
							</b-card>
						</b-col>
					</b-row>
				</div>
			</template>

			<div class="w-100 mb-5 pt-4 pb-4 border-b-semi-grey">
				<template v-if="display.data.length > 0">
					<p class="mb-1 sub-heading-1-1 px-4">{{$t('hotel.room-type.room-type')}}</p>
					<p class="body-2-2-1 sub-title text-15 mb-4 px-4">{{$t('hotel.room-type.home-sub')}}</p>
					<div class="w-100 px-4" v-if="display.data.length < 2">
						<div class="border radius-6 w-100 mb-3" :id="data.id" v-for="(data, index) in display.data">
							<div class="w-100 px-3 pt-3">
								<div class="img-hover-zoom radius-6">
									<!-- <img :src="data.image[0].image_url" v-if="data.image.length > 0" class="img-fit slider-hover" :alt="getMerchant.name" style="height:275px;"> -->
									<flickity ref="flickity" class="" :options="freeScrollSliderGallery" v-if="data.image.length != 0 ">
										<div class="carousel-cell w-100" v-for="image in data.image">
											<div class="img-hover-zoom radius-6 w-100 position-relative bg-dark-transparent" style="height: 250px;">
												<img :src="image.image_url" class="slider-hover w-100 h-100 z-index-1045 position-relative" :alt="getMerchant.name" style="object-fit: contain;">
                        <div class="position-absolute w-100 z-index-1042 bg-blur-overlay" :style="{ backgroundImage: `url('${image.image_url}')` }"></div>
											</div>
										</div>
									</flickity>
									<img :src="image_undefine" v-else class="img-fit slider-hover" :alt="getMerchant.name" style="height:250px;">
								</div>
								<div class="pb-1 pt-3 w-100">
									<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
										<p class="mb-1 body-1-2 font-bold text-18">{{data.name}}</p>
									</router-link>
									<p class="mb-0 body-2-2 text-14">{{$t('hotel.starting-from')}}:</p>
									<p class="mb-2 body-2-2-3 text-16 text-orange">{{formatCurrency(data.best_price.final_price)}}</p>
									<div class="pb-2">
										<div class="d-inline-block mr-2 mb-1" v-show="data.room_size !== '0'">
											<i class="simple-icon-size-fullscreen text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
											<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.room_size}} m²</p>
										</div>
										<div class="d-inline-block mr-2 mb-1">
											<i class="simple-icon-home text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
											<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.total_rooms}} {{$t('hotel.room-type.bedrooms')}}</p>
										</div>
										<div class="d-inline-block mr-2">
											<i class="simple-icon-grid text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
											<p class="mb-0 body-2-1 d-inline-block align-middle text-truncate">
												<template v-for="(bed, index) in data.bed">
													{{bed.qty}} {{bed.name}}<span v-if="index + 1 < data.bed.length">,</span>
												</template>
											</p>
										</div>
									</div>
									<p class="mb-0 body-2-2-1 mb-0 text-15 text-truncate-2">{{data.desc}}</p>
									<div class="mt-3">
										<div class="d-inline-block mr-3 mb-3">
											<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
												<button type="button" class="px-4 ga-btn-primary-md ga-btn-primary-outline">{{$t('hotel.concierge.fitur.read-more')}}</button>
											</router-link>
										</div>
										<div class="d-inline-block mb-3">
											<router-link :to="'/'+getMerchant.code+'/hotel-direct-detail/room_type/room_type/'+data.id+''">
												<button type="button" class="px-4 ga-btn-primary-md ga-btn-primary">{{$t('hotel.action.book-now')}}</button>
											</router-link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="" v-else>
						<flickity ref="flickity" class="mb-3 ml-4" :options="freeScrollSlider">
							<div class="carousel-cell p-3 border radius-6 w-90 mr-3" :class="{'pr-4':index == display.data.length - 1}" v-for="(data, index) in display.data">
								<div class="w-100">
									<div class="img-hover-zoom radius-6">
										<flickity ref="flickity" class="" :options="freeScrollSliderGallery" v-if="data.image.length != 0 ">
										<div class="carousel-cell w-100" v-for="image in data.image">
											<div class="img-hover-zoom radius-6 blur-image-bg" style="height: 250px;">
												<img :src="image.image_url" class="slider-hover img" :alt="getMerchant.name">
                        <div class="bg" :style="{ backgroundImage: `url('${image.image_url}')` }"></div>
											</div>
										</div>
									</flickity>
									<img :src="image_undefine" v-else class="img-fit slider-hover" :alt="getMerchant.name" style="height:250px;">
									</div>
									<div class="w-100 pt-3">
										<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
											<p class="mb-2 body-1-2 font-bold text-18">{{data.name}}</p>
										</router-link>
										<p class="mb-0 body-2-2 text-13">Starting From:</p>
										<p class="mb-2 body-2-2-3 text-16 text-orange">{{formatCurrency(data.best_price.final_price)}}</p>
										<div class="mb-3">
											<div class="d-inline-block mr-2" v-show="data.room_size !== '0'">
												<i class="simple-icon-size-fullscreen text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
												<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.room_size}} m²</p>
											</div>
											<div class="d-inline-block mr-2">
												<i class="simple-icon-home text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
												<p class="mb-0 body-2-1 d-inline-block align-middle">{{data.total_rooms}} {{$t('hotel.room-type.bedrooms')}}</p>
											</div>
											<div class="d-inline-block mr-2">
												<i class="simple-icon-grid text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
												<p class="mb-0 body-2-1 d-inline-block align-middle">
													<template v-for="(bed, index) in data.bed">
														{{bed.qty}} {{bed.name}}<span v-if="index + 1 < data.bed.length">,</span>
													</template>
												</p>
											</div>
										</div>
										<!-- <p class="mb-0 body-2-2-1 mb-0 text-15 text-truncate">{{room_type.desc}}</p> -->
										<div class="row slim-grid-row mt-3 pt-2">
											<div class="col-6 col-md-6 mb-2">
												<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
													<button type="button" class="ga-btn-primary-md ga-btn-primary-outline">{{$t('hotel.concierge.fitur.read-more')}}</button>
												</router-link>		        					
											</div>
											<div class="col-6 col-md-6">
												<router-link :to="'/'+getMerchant.code+'/hotel-direct-detail/room_type/room_type/'+data.id+''">
													<button type="button" class="ga-btn-primary-md ga-btn-primary">{{$t('hotel.action.book-now')}}</button>
												</router-link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</flickity>
					</div>
					<div class="px-4 mb-2 mt-4" v-if="display.data.length > 2">
						<router-link :to="'/'+getMerchant.code+'/room-type'">
							<div class="w-100 radius-12 text-center mt-3 g-btn-lg border-green text-semi-dark">
								<p class="mb-0 d-inline-block aling-middle text-semi-dark text-12">{{$t('hotel.concierge.fitur.read-more')}}</p>
								<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-10 text-semi-dark"></i>
							</div>
						</router-link>
					</div>
				</template>
			</div>
		</b-skeleton-wrapper>
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'
	import moment from 'moment';
	import {get} from '@/services/index.js'
  import {formatCurrency,formatDate} from '@/utils/index.js'
	export default{
		props:{
			data_source:{
				type: String,
				default: 'self'
			},
			parent_data: {
				type: Array,
				default: () => []
			},
			is_load: {
				type: Boolean,
				default: true
			}
		},
		components:{
			Flickity
		},
		data(){
			return{
				loading: true,
				freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 4000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: true,
          wrapAround: true,
          contain: false,
          cellAlign: 'left',
          groupCells: 1
        },
        freeScrollSliderGallery: {
          initialIndex: 0,
          autoPlay: 4000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: false,
          wrapAround: false,
          contain: false,
          cellAlign: 'left',
          groupCells: false
        },
        room_type: '',
        date:{
					check_in: moment().toDate(),
					check_out: moment(moment().toDate()).add(this.$defaultFilterBE('night'),'d').toDate()
				},
				image_undefine: 'https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png'
			}
		},
		mounted(){
			if(this.data_source == 'self'){
				this.loadRoomType()
			}
		},
		computed:{
			...mapGetters(['getMerchant']),
			display(){
				let return_data = {
					data: this.room_type,
					loading: this.loading
				}
				if(this.data_source == 'parent'){
					return_data = {
						data: this.parent_data,
						loading: this.is_load
					}
				}
				return return_data
			}
		},
		methods:{
			loadRoomType(){
				return new Promise((success,fail)=>{
					this.loading = true
					get("CORE_HOTEL",`room-type-list?adult=${this.$defaultFilterBE('adult')}&child=0&infant=0&merchant_id=${this.getMerchant.id}&check_in_date=${this.formatTime(this.date.check_in)}&check_out_date=${this.formatTime(this.date.check_out)}&use_promotion_combine=true`).then(response=>{
						if (response.data.success) {
							this.room_type = response.data.data
							success()
						}else{
							fail(response.data.message)
						}
						this.loading = false
					})
				})
			},
			formatTime(date){
				let format = "YYYY-MM-DD"
        return moment(date).format(format)
      },
      formatCurrency(data) {
        return formatCurrency(data)
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/RoomTypePreviewMobile.vue